import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateLostAndFoundIssueInput,
  CreateLostAndFoundIssueResponse,
  MutationCreateLostAndFoundIssueBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateLostAndFoundIssue } from '../queries/CreateLostAndFoundIssue';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateLostAndFoundIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateLostAndFoundIssueResponse>;
}

// SearchLostAndFoundIssue Service
export const { createLostAndFoundIssue, useCreateLostAndFoundIssue } = ((): {
  createLostAndFoundIssue: ServiceMethod;
  useCreateLostAndFoundIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateLostAndFoundIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: Record<keyof CreateLostAndFoundIssueInput, any>[],
        options?: ConnectionOptions
      ): Promise<CreateLostAndFoundIssueResponse> => {
        debug.log('createLostAndFoundIssue,createLostAndFoundIssue.input', 'INPUT', payload);
        const values: CreateLostAndFoundIssueInput[] = payload;
        const args: MutationCreateLostAndFoundIssueBulkArgs = {
          input: {
            values: values.map((value) => ({
              crewMemberEmail: value?.crewMemberEmail || null,
              crewMemberName: value?.crewMemberName || null,
              crewMemberPhone: value?.crewMemberPhone || '',
              outboundDatetime: value?.outboundDatetime || null,
              outboundFlightNumber: value?.outboundFlightNumber || null,
              outboundFlightName: value?.outboundFlightName || null,
              description: value?.description || null,
              itemLost: value?.itemLost || null,
              tripId: value?.tripId || null,
              vehicleId: value?.vehicleId || null,
              datetime: value?.datetime || null,
              dispatcherId: value?.dispatcherId || null,
              driverId: value?.driverId || null,
              notes: value?.notes || '',
              returnStatus: value?.returnStatus || null,
              shippingAddress: value?.shippingAddress || '',
              shippingCity: value?.shippingCity || '',
              shippingCost: value?.shippingCost || 0,
              shippingMethod: value?.shippingMethod || '',
              shippingStateCode: value?.shippingStateCode || '',
              shippingZipCode: value?.shippingZipCode || '',
              trackingNumber: value?.trackingNumber || '',
              documents: value?.documents || [],
            })),
          },
        };
        debug.log('createLostAndFoundIssue,createLostAndFoundIssue.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'createLostAndFoundIssueBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('createLostAndFoundIssue,createLostAndFoundIssue.response', 'RESPONSE', res);
        return getProperty('createLostAndFoundIssueBulk.output', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createLostAndFoundIssue: fetch,
    useCreateLostAndFoundIssue: useService,
  };
})();
